import inView from "in-view";
import { els } from './variables';

const sectionInView = () => {
	inView('.home .layer').on('enter', el => {
		el.classList.add('in-view');


	});
}

/**
 * Tracks the current scroll position on the page.
 *
 * @type {Number}
 */
let currentScrollPoint;

const ctaImages = document.querySelectorAll('.cta-with-image-animation .image');

const ctaImage = () => {
	/**
	 * Update the current scroll position.
	 *
	 * @type {Number}
	 */
	currentScrollPoint = (els.html && els.html.scrollTop) || els.body.scrollTop;

	ctaImages.forEach((e)=>{
		const image = e.querySelectorAll('img');
		const rect = e.getBoundingClientRect();
		const imageHeight = image[0].offsetHeight / 3 * 2;
		const triggerPoint = rect.x + imageHeight;
		
		if( inView.is(e) && currentScrollPoint > triggerPoint ) {
			image[0].style.right = '20%';
		} 

		if( currentScrollPoint < triggerPoint ) {
			image[0].style.right = '0';
		} 
	});

}

document.addEventListener('DOMContentLoaded', sectionInView);
window.addEventListener('scroll',ctaImage);

